import React from 'react';
import { BarChart3 } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import TooltipValores from '../tooltips/TooltipValores';

const GraficoValores = ({ dadosGraficoValores }) => {
  return (
    <div className="space-y-6">
      <div className="rounded-lg p-4 mb-4 bg-[color:var(--surface-muted)] border border-[color:var(--border)]">
        <h4 className="text-sm font-medium text-[color:var(--text-primary)] mb-2 inline-flex items-center gap-2">
          <BarChart3 className="h-4 w-4 text-[color:var(--accent)]" />
          Análise de Valores por Conta Bancária
        </h4>
        <p className="text-xs text-[color:var(--text-muted)]">
          Comparação entre valor total, valor pago e valor em aberto para cada conta bancária
        </p>
      </div>
      
      {/* Legenda para Valores */}
      <div className="flex flex-wrap gap-4 justify-center mb-4">
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 bg-[color:var(--accent)] rounded"></div>
          <span className="text-sm text-[color:var(--text-primary)]">Valor Total</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 bg-[color:var(--status-good,var(--accent))] rounded"></div>
          <span className="text-sm text-[color:var(--text-primary)]">Valor Pago</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 bg-[color:var(--status-bad,var(--accent))] rounded"></div>
          <span className="text-sm text-[color:var(--text-primary)]">Valor em Aberto</span>
        </div>
      </div>
      
      <div className="h-80">
        {dadosGraficoValores.length === 0 ? (
          <div className="h-full flex items-center justify-center border border-dashed border-[color:var(--border)] rounded-lg bg-[color:var(--surface-muted)]">
            <p className="text-sm text-[color:var(--text-muted)]">Sem dados de valores para exibir.</p>
          </div>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={dadosGraficoValores} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid stroke="var(--border)" strokeDasharray="3 3" />
              <XAxis 
                dataKey="nome" 
                angle={-45}
                textAnchor="end"
                height={80}
                fontSize={12}
              />
              <YAxis tickFormatter={(value) => `R$ ${(value / 1000).toFixed(0)}k`} />
              <Tooltip content={<TooltipValores />} />
              <Bar dataKey="valorTotal" fill="var(--chart-1, #3B82F6)" name="Valor Total" />
              <Bar dataKey="valorPago" fill="var(--status-good, #10B981)" name="Valor Pago" />
              <Bar dataKey="valorAberto" fill="var(--status-bad, #EF4444)" name="Valor Aberto" />
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
};

export default GraficoValores;




